import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectPortfoliosWithSignals, selectStarredPortfolios} from "../../Store/slices/portfolios.slice";
import {selectUserFields} from "../../Store/slices/user.slice";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import {Col, Layout, Row, Card, Space, Divider, Typography} from "antd";
import HomeHeader from "../HomeHeader";
import React from "react";
import DashboardCards from "./DashboardCards";
import TickerEvents from "../../SuperComponents/TickerEvents/TickerEvents";
import PortfolioRibbon from "../../Pages/Portfolio/PortfolioRibbon/PortfolioRibbon";
import Widget from "../../Components/Widget";
import Placeholder from "../../Components/Placeholder";
import {SettingsRounded, LaunchRounded} from "@mui/icons-material";
import Masonry from '@mui/lab/Masonry';
import { styled } from '@mui/material/styles';
const { Content } = Layout;



const StarredPortfolios = ({portfolios})=>{
    if (portfolios.length === 0) return (
        <Placeholder
            text={'No Starred Portfolios'}
        />
    );
    return (
            <Space direction={'vertical'} style={{width: '100%', height: 400, overflowY: 'scroll'}}>
                {portfolios.map((portfolio)=>(
                    <PortfolioRibbon portfolio={portfolio} width={'100%'} />
                ))}
            </Space>
    )
}


const IAPlatformAppHome = ({ widgets }) => {
    const portfolios = useSelector(selectPortfoliosWithSignals);
    const settings = useSelector((state) => selectUserFields(state, 'settings'));
    const starredPortfolios = useSelector(selectStarredPortfolios);

    return (
        <Layout className={'app-home'} style={{ height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}>
            <Content style={{
                height: 'auto',
            }}>
                <Row className={'px-3'} justify={'center'} gutter={[96, 32]} align={'top'} wrap={true}>
                    <Col flex={'0 0 600px'}>
                        <HomeHeader username={settings?.display_name??""} appsList={settings?.apps ?? []} />
                        <Divider/>
                        <Card bordered={false}>
                            <Row gutter={[64, 16]} justify={'start'}>
                              {widgets.map((app) => (
                                <Col key={app.label} span={6}>
                                  <Widget config={app} />
                                </Col>
                              ))}
                            </Row>
                        </Card>
                        <Divider orientation={'left'}/>
                        <Typography.Title level={4} className={'ml-3'}>
                            {starredPortfolios.length} Active Portfolios
                        </Typography.Title>
                        <StarredPortfolios portfolios={starredPortfolios} />
                    </Col>
                    <Col flex={'0 0 700px'} offset={1} style={{paddingTop: '50px'}}>
                        <DashboardCards portfolios={portfolios} />
                        <Divider/>
                        <Card bordered={false}>
                            <TickerEvents/>
                        </Card>
                    </Col>
                </Row>
              <Divider/>
            </Content>
        </Layout>
    );
};

export default IAPlatformAppHome;